import React, { useEffect, useState } from "react";
import Loader from "../loader/Loader";
import Navigation from "../components/Navigation";
import { useDispatch, useSelector } from "react-redux";
import "./Survey.css";
import { Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import * as surveyActions from "../redux/survey/survey.actions";
import moment from "moment";
import { toast } from "react-toastify";
import SurveyStart from "./SurveyStart";
import { isUserParticipatedInSurveyAction, GET_SURVEY_QUESTIONS_RESET, getAttemptSurveyQuestionsListAction } from "../redux/attemptSurvey/attemptSurvey.actions";
import AttemptedUserModal from "../components/Models/AttemptedUserModal";
import QuestionListing from "./QuestionListing";
import ParticipantDropdowns from "../components/ParticipantDropdowns";
import { getSurveyParticipantsCount } from "../helper/surveyParticipants";

const ContributedDetails = () => {
  const [data, setData] = useState({});
  const [startSurvey, setStartSurvey] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const id = useParams().id;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loading = useSelector((state) => state.surveyInfo.loading);
  const details = useSelector((state) => state.surveyInfo.details);
  const selectedLanguage = useSelector(state => state.languageInfo.selectedLanguage);
  const profileData = useSelector(state => state.authInfo.profileData);
  const isLoggedIn = !!profileData?.data?._id;
  const { isUserParticipatedInSurvey } = useSelector((state) => state.attemptSurveyInfo);
  const hasUserParticipated = isUserParticipatedInSurvey?.data?.filter(survey => survey._id === id)?.length > 0 ?
    isUserParticipatedInSurvey?.data?.find(survey => survey._id === id)?.users?.includes(profileData?.data?._id) :
    false;
  // Check if current user is the organizer (createdByUser is an array)
  const userCreatedThisSurvey =
    details?.createdBy === profileData?.data?._id ||
    details?.createdByUser?.[0]?._id === profileData?.data?._id ||
    data?.createdBy === profileData?.data?._id ||
    data?.createdByUser?.[0]?._id === profileData?.data?._id;

  const surveyQuestions = useSelector((state) => state?.attemptSurveyInfo?.surveyQuestions);

  const participantsCount = getSurveyParticipantsCount(data, {
    attendedUsers: surveyQuestions?.data?.attendedUsers,
  });

  // Helper function to get survey URL
  const getSurveyUrl = (surveyId) => {
    const baseUrl = process.env.REACT_APP_SURVEY_RESULT_BASE_URL || 'https://votiamo.com/';
    const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    return `${normalizedBaseUrl}survey-details/${surveyId}`;
  };

  useEffect(() => {
    if (id) {
      dispatch(surveyActions.getPublicSurveyDetails(id));
      dispatch({ type: GET_SURVEY_QUESTIONS_RESET });
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(isUserParticipatedInSurveyAction());
      dispatch(getAttemptSurveyQuestionsListAction(id));
    }
  }, [navigate, dispatch, isLoggedIn]);

  useEffect(() => {
    if (details && Object.keys(details).length > 0) {
      setData({ ...details });
    } else {
      setData({});
    }
  }, [details]);

  const handleButtonClick = (url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleStartSurvey = () => {
    if (!isLoggedIn) {
      navigate("/auth");
      toast.info("Please login or register to participate in this survey.");
    } else {
      if (userCreatedThisSurvey) {
        toast.info("You cannot participate in your own survey.");
      } else {
        setStartSurvey(prevState => !prevState);
      }
    }
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);
  };

  const closeModal = () => {
    setSelectedUser(null);
  };

  return (
    <>
      <Navigation />
      {loading ? (
        <Loader />
      ) : (
        <>
          {
            data && Object.keys(data).length > 0 ?
              <>
                <section className="survey">
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <span className="page_breadcrumb">
                          <img onClick={e => {
                            navigate("/sondaggi")
                          }} src={`${process.env.PUBLIC_URL}/images/survey/backIcon.png`} style={{ cursor: 'pointer' }} />
                          <ul>
                            <li onClick={e => {
                              navigate("/sondaggi")
                            }} style={{ cursor: 'pointer' }}>Tutto</li>
                            <li>{data?.title}</li>
                          </ul>
                        </span>
                      </div>
                      <div className="col-12">
                        <div className="row mb-5">
                          <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 mt-4">
                            <div className="survey_thumbnail_card">
                              <img src={data?.banner ? `${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${data.banner}` : `${process.env.PUBLIC_URL}/images/votiamo_mini.png`} />
                              <div className="survey_thumbnail_content">
                                <div className="survey_thumbnail_left_content">
                                  <img src={`${process.env.PUBLIC_URL}/images/survey/giftIcon.png`} />
                                  <p><span>{data?.questionsLength || data?.questions?.length}</span> Domande{(data?.questionsLength > 1 || data?.questions?.length > 1) && `'s`}</p>
                                </div>
                                <div className="survey_thumbnail_right_content">
                                  <img src={data?.createdByUser?.[0]?.image ? `${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${data.createdByUser[0].image}` : `${process.env.PUBLIC_URL}/images/no_profile.png`} />
                                  <p>Creato da <span>{data?.createdByUser?.[0]?.name}</span></p>
                                </div>
                              </div>
                            </div>
                            {/* {
                              data?.prize &&
                              <>
                                <div className="survey_prize_card mt-4">
                                  <img src={`${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${data?.prize?.image}`} />
                                  <div className="survey_prize_content">
                                    <p>Premio in palio</p>
                                    <h6>Premi Totali : {data?.prize?.numberOfPrizes}</h6>
                                    <span>{data?.prize?.description}</span>
                                  </div>
                                </div>
                                {surveyQuestions?.data?.prize?.[0]?.winnerUser &&
                                  surveyQuestions.data.prize[0].winnerUser.length > 0 && (
                                    <>
                                      {surveyQuestions.data.prize[0].winnerUser.map(elem => (
                                        <div className="survey_winner mt-4" key={elem?._id} onClick={() => {
                                          setSelectedUser(elem)
                                        }}>
                                          <span className="survey_winner_heading">
                                            <img src={`${process.env.PUBLIC_URL}/images/survey/prizeIcon.png`} />
                                            Vincitore del sondaggio
                                          </span>
                                          <div className="survey_winner_content mt-3">
                                            <img src={elem?.image
                                              ? `${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${elem?.image}`
                                              : `${process.env.PUBLIC_URL}/images/no_profile.png`}
                                            />
                                            <div>
                                              <span className="survey_winner_name">{elem?.name}</span>
                                              {(elem?.countryName && elem.countryName.length > 0) && (
                                                <span className="survey_winner_place">
                                                  {elem?.regionName && elem.regionName.length > 0
                                                    ? `${elem.regionName[0]?.DescrRegione},`
                                                    : elem?.provinciaName && elem.provinciaName.length > 0
                                                      ? `${elem.provinciaName[0]?.DescrProvincia},`
                                                      : ''}
                                                  {elem.countryName[0]?.name}
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  )}
                              </>
                            } */}
                          </div>
                          {
                            startSurvey ?
                              <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 mt-4">
                                <QuestionListing id={id} question={surveyQuestions?.data?.questions} />
                              </div>
                              :
                              <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 mt-4">
                                <div className="survey_content">
                                  <div className="survey_content_tags d-flex gap-3">
                                    {data?.active ? (
                                      <span className="survey_card_status survey_card_active position-relative top-0 start-0">
                                        Attivo
                                      </span>
                                    ) : (
                                      <span className="survey_card_status survey_card_completed position-relative top-0 start-0">
                                        {selectedLanguage && selectedLanguage.name === "English" ? "Closed" : "Terminato"}
                                      </span>
                                    )}
                                    <span className="survey_card_status survey_card_completed position-relative top-0 start-0">
                                      Pubblico
                                    </span>
                                  </div>
                                  <div className="my-4">
                                    <h3 className="survey_title mt-3">{data?.title}</h3>
                                    <p className="survey_description mt-3">{data?.description}</p>
                                  </div>
                                  <div className="survey_link_section my-3 d-flex align-items-center gap-2">
                                    <strong>Link del sondaggio per l'app:</strong>
                                    <a
                                      href={getSurveyUrl(id)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="survey_link"
                                    >
                                      Apri sondaggio
                                    </a>
                                    <button
                                      style={{ border: "none", outline: "none", background: "#fff" }}
                                      className="copy_to_clipboard"
                                      onClick={() => {
                                        const surveyUrl = getSurveyUrl(id);
                                        navigator.clipboard.writeText(surveyUrl);
                                        toast("Link copiato.");
                                      }}
                                      title="Copy to Clipboard"
                                    >
                                      <img
                                        src={`${process.env.PUBLIC_URL}/images/survey/copy.png`}
                                        style={{ width: "20px" }}
                                        alt="Copy"
                                      />
                                    </button>
                                  </div>
                                  <div className="survey_extra_info d-flex justify-content-between">
                                    <div className="survey_extra mt-3">
                                      <div>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/images/survey/calendarBlueIcon.png`}
                                        />
                                        Fine <span>{moment(new Date(data?.setting?.[0]?.endDate)).format("DD MMM, YY")}</span>
                                      </div>
                                      <div>
                                        <img
                                          src={`${process.env.PUBLIC_URL}/images/survey/peopleBlueIcon.png`}
                                        />
                                        <span>{participantsCount} </span>Partecipanti
                                      </div>
                                    </div>
                                    <div className="right_action d-flex justify-content-right">
                                      {
                                        <div
                                          className="survey_show_result_btn mt-3"
                                          onClick={handleStartSurvey}
                                        >
                                          <img
                                            src={`${process.env.PUBLIC_URL}/images/survey/surveyIcon.png`}
                                            alt="Calendar Icon"
                                          />
                                          View My Survey
                                        </div>
                                      }
                                      {(data?.setting?.[0]?.liveResult || !data?.active) && (
                                        <div
                                          className="survey_show_result_btn mt-3"
                                          onClick={(e) => navigate(`/survey-results/${data._id}`)}
                                        >
                                          <img
                                            src={`${process.env.PUBLIC_URL}/images/survey/calendarIcon.png`}
                                            alt="Calendar Icon"
                                          />
                                          Mostra i risultati del sondaggio
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <hr className="row_divider" />
                                <div className="survey_createdby_content">
                                  {
                                    data?.group && data?.group.length > 0 ? (
                                      <div className="row">
                                        <div className="col-12">
                                          <h6 className="survey_section_heading">Creato da</h6>
                                        </div>
                                        <div className="col-lg-6 mt-3">
                                          <div className="createdby_left_box">
                                            <span>Nome del gruppo</span>
                                            <h5>{data?.group[0]?.name}</h5>
                                            <p>{data?.group[0]?.description}</p>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 mt-3">
                                          <ul className="createdby_right_box">
                                            <li>Nome del referente<span>{data?.group[0]?.refName}</span></li>
                                            <li>Cognome del referente<span>{data?.group[0]?.refSurname}</span></li>
                                            <li>Email<span>{data?.group[0]?.email}</span></li>
                                            <li>Numero di telefono<span>{data?.group[0]?.phone}</span></li>
                                            <li><span className="notranslate" translate="no">{selectedLanguage && selectedLanguage.name === "English" ? "Country" : "Paese"}</span><span>{data?.group[0]?.country_name}</span></li>
                                            {
                                              data?.group[0]?.country_name === "Italy" ?
                                                <>
                                                  <li>Regione<span>{data?.group[0]?.region_name}</span></li>
                                                  <li>Provincia<span>{data?.group[0]?.provincia_name}</span></li>
                                                  <li>Comune<span>{data?.group[0]?.comune_name}</span></li>
                                                </> :
                                                <>
                                                  <li>Stato<span>{data?.group[0]?.state_name}</span></li>
                                                  <li>Città<span>{data?.group[0]?.city_name}</span></li>
                                                </>
                                            }
                                            <li>Primo indirizzo<span>{data?.group[0]?.addressLine1}</span></li>
                                            <li>Secondo indirizzo<span>{data?.group[0]?.addressLine2}</span></li>
                                          </ul>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="row">
                                        <div className="col-12">
                                          <h6 className="survey_section_heading">Creato da</h6>
                                        </div>
                                        <div className="col-lg-6 mt-3">
                                          <div className="createdby_left_box">
                                            <img style={{ width: "50px", height: "50px" }} className="rounded-circle" src={data?.createdByUser?.[0]?.image ? `${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${data.createdByUser[0].image}` : `${process.env.PUBLIC_URL}/images/no_profile.png`} />
                                            <h5>{data?.createdByUser?.[0]?.name}</h5>
                                          </div>
                                        </div>
                                        <div className="col-lg-6 mt-3">
                                          <ul className="createdby_right_box">
                                            {data?.createdByUser?.[0]?.nation_country && <li><span className="notranslate" translate="no">{selectedLanguage && selectedLanguage.name === "English" ? "Country" : "Paese"}</span><span>{data?.createdByUser?.[0]?.countryName?.[0]?.name}</span></li>}
                                            {
                                              data?.createdByUser?.[0]?.nation_country?.id === "107" ?
                                                <>
                                                  {data?.createdByUser?.[0]?.region && <li>Regione<span>{data?.createdByUser?.[0]?.regionName?.[0]?.DescrRegione}</span></li>}
                                                  {data?.createdByUser?.[0]?.provincia && <li>Provincia<span>{data?.createdByUser?.[0]?.provinciaName?.[0]?.DescrProvincia}</span></li>}
                                                  {data?.createdByUser?.[0]?.comune && <li>Comune<span>{data?.createdByUser?.[0]?.comuneName?.[0]?.DescrComune}</span></li>}
                                                </> :
                                                <>
                                                  {data?.createdByUser?.[0]?.region_state && <li>Stato<span>{data?.createdByUser?.[0]?.region_state?.id}</span></li>}
                                                  {data?.createdByUser?.[0]?.city && <li>Città<span>{data?.createdByUser?.[0]?.cityName?.[0]?.name}</span></li>}
                                                </>
                                            }
                                          </ul>
                                        </div>
                                      </div>
                                    )
                                  }
                                </div>
                                {data?.sponsors && data?.sponsors?.length > 0 && (
                                  <>
                                    <hr className="row_divider" />
                                    <div className="survey_sponsor_content">
                                      <div className="row">
                                        <div className="col-12">
                                          <h6 className="survey_section_heading"><img src={`${process.env.PUBLIC_URL}/images/survey/moneyIcon.png`} /> Sponsorizzato da</h6>
                                        </div>
                                        <div className="col-12">
                                          <div className="row">
                                            {
                                              data?.sponsors?.map(elem => (
                                                <Col xl={3} lg={4} md={6} sm={4} xs={6} className="mt-3" key={elem._id}>
                                                  <div className="sponsor_card">
                                                    <img src={`${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${elem?.image}`} />
                                                    <h6>{elem?.name}</h6>
                                                    <p style={{ userSelect: "none", cursor: "pointer" }} onClick={e => handleButtonClick(elem?.link)}>{elem?.link}</p>
                                                  </div>
                                                </Col>
                                              ))
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <hr className="row_divider" />
                                  </>
                                )}

                                <ParticipantDropdowns
                                  attendedUsers={surveyQuestions?.data?.attendedUsers}
                                  selectedLanguage={selectedLanguage}
                                  profileId={profileData?.data?._id}
                                  userCreatedThisSurvey={userCreatedThisSurvey}
                                  isLoggedIn={isLoggedIn}
                                  hasUserParticipated={hasUserParticipated}
                                  onUserClick={handleUserClick}
                                />

                              </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </> :
              <h2 className="text-muted text-center mt-3">No Data Found</h2>
          }

          {/* Modal component */}
          {selectedUser && (
            <AttemptedUserModal
              user={selectedUser}
              onHide={closeModal}
            />
          )}
        </>
      )}
    </>
  );
};

export default ContributedDetails;